import React, { useEffect, useState } from 'react';
import { useIntl } from 'umi';
import "./index.scss"
export default function Marquee({ list }) {
  const [selected, setSelected] = useState(0);
  const { formatMessage } = useIntl();

  if (!list || !list.length) return null;

  const time = 8000;

  let timeout;
  function handleTimeout(curSelected) {
    const newSelected = curSelected === list.length - 1 ? 0 : selected + 1;
    setSelected(newSelected);
    timeout = setTimeout(() => handleTimeout(newSelected), time);
  }
  useEffect(() => {
    timeout = setTimeout(handleTimeout, time);
    return () => {
      clearTimeout(timeout);
    };
  }, []);

  return (
    <div className='dbo-commont-tip-text'>{formatMessage({ id: list[selected] })}</div>
  );
}
